import { createRFXQuestionAttachmentMutation } from 'gql/queries/createRFXQuestionAttachmentQuery';
import { RFXRevisionedId } from 'interfaces/RFXBackendModel';

import { UIInput } from '../../types/uiTypes';

export interface CreateRFXQuestionAttachmentInput extends UIInput {
  rfxQuestionId: RFXRevisionedId;
  externalId: string;
  filename: string;
  description: string;
  stagingS3Uri: string;
  documentType: string;
}

export interface CreateRFXQuestionAttachmentOutput {
  rfxQuestionId: RFXRevisionedId;
  externalId: string;
  status: string;
}

export async function createRFXQuestionAttachment({
  apolloClient,
  rfxQuestionId,
  externalId,
  filename,
  description,
  stagingS3Uri,
  documentType
}: CreateRFXQuestionAttachmentInput): Promise<CreateRFXQuestionAttachmentOutput> {
  const response = await apolloClient.mutate({
    mutation: createRFXQuestionAttachmentMutation,
    variables: {
      rfxQuestionId,
      externalId,
      filename,
      description,
      stagingS3Uri,
      documentType
    }
  });

  return response.data.createRFXQuestionAttachment as CreateRFXQuestionAttachmentOutput;
}
